module.exports = __webpack_public_path__ + "static/img/Easton_Wood_mobile.da7afc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Easton_Wood_mobile.jpg
// module id = kj7H
// module chunks = 0